// extracted by mini-css-extract-plugin
export default {"survey-page":"page_survey-page__XGig4"};